import { render } from "./DeliveryModal.vue?vue&type=template&id=9dece164&scoped=true"
import script from "./DeliveryModal.vue?vue&type=script&lang=js"
export * from "./DeliveryModal.vue?vue&type=script&lang=js"

import "./DeliveryModal.vue?vue&type=style&index=0&id=9dece164&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dece164"]])

export default __exports__